export default class ManifestService {
    /* @ngInject */
    constructor() {
        this.manifest = window.manifest;
    }

    getManifest() {
        return this.manifest;
    }

    getValue(key) {
        return this.manifest[key];
    }

    region() {
        return this.manifest.Region;
    }

    userPool() {
        return this.manifest.UserPool;
    }

    identityPool() {
        return this.manifest.IdentityPool;
    }

    authLamda() {
        return this.manifest.AuthLamda;
    }

    iotEndpointATS() {
        return this.manifest.IotEndpointATS;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/manifest.service.js